import { html, unsafeCSS } from 'lit';
import { BaseElement, customElement } from '../base-element';
import styles from './background.scss?inline';

@customElement('ps-background')
export class BackgroundWC extends BaseElement {
  static styles = unsafeCSS(styles);

  render() {
    return html`
      <span class="c-background">
        <slot></slot>
      </span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-background': BackgroundWC;
  }
}
